import { Navigate, useParams } from 'react-router';
import routes from '@commons/routes';

export function RedirectOldClientFolder() {
  const { folderName } = useParams<{ folderName: string }>();
  return <Navigate to={routes.routes.clientFolder(folderName || '')} replace />;
}
